export default __webpack_public_path__ + "static/media/illium.fc1576f5.png";